export const PAGE_TITLES = {
  '/': 'Login',
  '/recuperar-senha': 'Recuperar Senha',
  '/autenticacao': 'Autenticação',
  '/autenticacao-sso': 'Autenticação SSO',
  '/dashboard': 'Home',
  '/dashboard/chat': 'Chat',
  '/dashboard/big-questions': 'Dispersão',
  '/dashboard/big-views': 'Visões',
  '/dashboard/big-numbers': 'Números',
  '/dashboard/conversions': 'Conversões',
  '/dashboard/market-share': 'Market Share',
  '/dashboard/my-panels': 'Meus Painéis',
  '/dashboard/hour-by-hour': 'Hora a Hora',
  '/dashboard/fidelity': 'Fidelidade',
  '/dashboard/proposals': 'Propostas D0',
} as const

export type PagePath = keyof typeof PAGE_TITLES

